import React from 'react';
import Translate from '../../../../../Translate/Translate';
import app from '../../../../../../helpers/app';
import {useQuery} from '@tanstack/react-query';
import {INotificationModel} from '../../../../../../@interfaces/models/Notification/INotificationModel';
import RenderIf from '../../../../../RenderIf/RenderIf';
import ErrorRepresentation from '../../../../../ErrorRepresentation/ErrorRepresentation';
import ServerNotification from '../../../../../Notifications/server-notifications/ServerNotification';

export function getMessagesQueryKey(filters: any = undefined) {
    const userId = app('auth').getUser()?.id;

    return app('queryKeys').getCustomRequestQueryKey(`user-${userId}-notifications`, filters);
}

export default function Messages(props: {
    maxHeight?: number,
    wrapperRef: React.RefObject<HTMLDivElement>,
}) {
    const filters = {
        unreadOnly: true,
        offset: 0,
    };

    const key = getMessagesQueryKey(filters);
    const {data, error} = useQuery<INotificationModel<any>[], Error>(key, () => {
        return app('http').route('profile.notifications.index', undefined, {
            body: filters,
        });
    }, {
        useErrorBoundary: false,
        staleTime: 5 * 60 * 1000,
    });


    return <div
            className="notifications__list__body"
            style={props.maxHeight != null ? {maxHeight: props.maxHeight} : undefined}
            ref={props.wrapperRef}
    >
        {error ? <ErrorRepresentation error={error} className="py-1 px-2"/> : null}

        <RenderIf expression={!data?.length}>
            <div className="notifications__list__no-records-message">
                <Translate message="@common-phrases.no-records-found"/>
            </div>
        </RenderIf>

        {data?.map(
                item => <ServerNotification key={item.id} notification={item}/>
        )}
    </div>;
}
